import type { InterventionTabModulesProps } from "./intervention-tab-modules.type";

import InterventionJobModulesTable from "@/modules/intervention/intervention-job-modules-table";
import InterventionJobModulesTriggers from "@/modules/intervention/intervention-job-modules-triggers";
import "./intervention-tab-modules.style.less";

const InterventionTabModules = ({
  intervention,
}: InterventionTabModulesProps) => {
  return (
    <div className="intervention-tab-modules-wrapper">
      <InterventionJobModulesTriggers intervention={intervention} />
      <InterventionJobModulesTable intervention={intervention} />
    </div>
  );
};

export default InterventionTabModules;
